// extract user ID from JWT token
// and returns it only if it's a valida UUID v4
export const getSubjectFromJwt = (token: any): string | null => {
  try {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace('-', '+').replace('_', '/')

    const decoded = JSON.parse(
      typeof window !== 'undefined'
        ? window.atob(base64)
        : Buffer.from(base64, 'base64').toString('ascii')
    )
    const subject = decoded.sub as string

    if (
      !subject.match(
        /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i
      )
    ) {
      return null
    }

    return subject || null
  } catch (error) {
    return null
  }
}
